import React from 'react';
import axios from 'axios';

import SingleStockist from './SingleStockist';

class StockistsPromotions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stockists: [],
      hiddenStockists: [],
      hiddenStockistsClasses: 'stockists__list--hidden',
      showMoreClasses: 'show-more__container',
      customerCountry: '',
    };

    this.showMoreEvent = this.showMoreEvent.bind(this);
    this.showLessEvent = this.showLessEvent.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
    this.handleStockistsList = this.handleStockistsList.bind(this);
  }

  showMoreEvent() {
    this.setState({
      hiddenStockistsClasses: '',
      showMoreClasses: 'show-more__container hidden',
    });
  }

  showLessEvent() {
    this.setState({
      hiddenStockistsClasses: 'stockists__list--hidden',
      showMoreClasses: 'show-more__container',
    });
  }

  onSuccess(geoipResponse) {
    this.setState({
      customerCountry: geoipResponse.country.names.en,
    });
  }

  onError(error) {
    window.console.log('ERROR: ', error);
  }

  handleStockistsList() {
    const {customerCountry} = this.state;
    const site = window.theme.activeTheme ? window.theme.activeTheme.split('-')[1] : '';
    const pathname = location.pathname;
    const orderPriority = {
      major: 1,
      core: 2,
      limited: 3,
      'accessories only': 4,
    };

    axios({
      method: 'GET',
      url: 'https://bates-stockists-api.herokuapp.com/all-stockists/' + site,
      responseType: 'JSON',
    })
      .then(response => {
        const promotionStockists = response.data.stockists.filter(stockist => stockist.promo1Url.includes(pathname) || stockist.promo2Url.includes(pathname));
        if (promotionStockists.length > 0) {
          const stockists = [];
          promotionStockists.forEach(stockist => {
            const data = {
              stockist,
              distance: '-10',
            };

            stockists.push(data);
          });

          const sortedStockists = stockists.sort((item1, item2) => {
            return orderPriority[item1.stockist.type.trim()] > orderPriority[item2.stockist.type.trim()] ? 1 : -1;
          });
          const visibleStockists = [];
          const hiddenStockists = [];

          sortedStockists.forEach(stockist => {
            if (stockist.stockist.country.trim() === customerCountry.trim()) {
              visibleStockists.push(stockist);
            } else {
              hiddenStockists.push(stockist);
            }
          });

          // if (sortedStockists.length > 10) {
          //   for (let i = 0; i < 10; i++) {
          //     visibleStockists.push(sortedStockists[i]);
          //   }
          //   for (let i = 10; i < sortedStockists.length; i++) {
          //     hiddenStockists.push(sortedStockists[i]);
          //   }
          // } else {
          //   for (let i = 0; i < sortedStockists.length; i++) {
          //     visibleStockists.push(sortedStockists[i]);
          //   }
          // }
          if (visibleStockists.length > 0) {
            this.setState({
              stockists: visibleStockists,
              hiddenStockists,
            });
          } else {
            this.setState({
              stockists: hiddenStockists,
            });
          }
        }
      })
      .catch(err => window.console.log(err));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.customerCountry !== prevState.customerCountry) {
      this.handleStockistsList();
    }
  }

  componentDidMount() {
    geoip2.country(this.onSuccess, this.onError);

    this.handleStockistsList();
  }

  render() {
    let majorIcon = window.stockistIcons.major;
    let coreIcon = window.stockistIcons.core;
    let limitedIcon = window.stockistIcons.limited;
    let mountsAccessoriesIcon = window.stockistIcons.mountsAccessories;
    let onlineOnlyIcon = window.stockistIcons.onlineOnly;
    let mobileIcon = window.stockistIcons.mobile;
    let saddleFitterIcon = window.stockistIcons.saddleFitter;
    let promo1Icon = window.stockistIcons.promo1;
    let promo2Icon = window.stockistIcons.promo2;

    const icons = {
      major: majorIcon,
      core: coreIcon,
      limited: limitedIcon,
      mobile: mobileIcon,
      'accessories only': mountsAccessoriesIcon,
      onlineOnly: onlineOnlyIcon,
      saddleFitter: saddleFitterIcon,
      promo1: promo1Icon,
      promo2: promo2Icon,
    };

    const {stockists, hiddenStockists, hiddenStockistsClasses, showMoreClasses} = this.state;

    return (
      <div className="container stockists__promotion">
        <div className="row">
          <div className="col-xs-12 col-lg-8 col-lg-offset-2">
            <div className="article-container">
              <div className="stockists__list">
                {
                  stockists.map((stockist, index) => <SingleStockist stockist={stockist.stockist} distance={stockist.distance} key={stockist.stockist.name.trim().split(' ').join() + index} icons={icons}/>)
                }
              </div>
              { hiddenStockists.length > 0 &&
                <div className={showMoreClasses}>
                  <div className="btn__show-more" onClick={this.showMoreEvent}>Show More
                    <span>
                      <svg aria-hidden="true" focusable="false" role="presentation" className="icon icon-arrow-down-small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M15 6.999l-5 2.594-5-2.594 2.5 3.123 2.178 2.724a.412.412 0 0 0 .642 0L15 6.999z" fill="#000" fillRule="evenodd"/>
                      </svg>
                    </span>
                  </div>
                </div>
              }

              { hiddenStockists.length > 0 &&
                <div className={hiddenStockistsClasses}>
                  <div className="stockists__list">
                    {
                      hiddenStockists.map((stockist, index) => <SingleStockist stockist={stockist.stockist} distance={stockist.distance} key={stockist.stockist.name.trim().split(' ').join() + index} icons={icons}/>)
                    }
                  </div>
                  <div className="show-more__container">
                    <div className="btn__show-more" onClick={this.showLessEvent}>Show Less
                      <span>
                        <svg aria-hidden="true" focusable="false" role="presentation" className="icon icon-arrow-up-small" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 13l-5-2.594L5 13l2.5-3.123 2.178-2.724a.412.412 0 0 1 .642 0L15 13z" fill="#000" fillRule="evenodd"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StockistsPromotions;
